module.exports = __webpack_public_path__ + "img/aiimage2.a1aac061.jpg";